<template>
  <div class="token-select">
    <div v-if="!isLoaded" class="token-select__loading">Loading...</div>

    <div v-else-if="!tokens.length" class="token-select__loading">You don't have any tokens to select :(</div>

    <template v-else>
      <div v-for="token in tokens" class="token-select__token">
        <div class="token-select__token-title">{{ isFft ? 'FFT' : 'NFCheese' }} #{{ token.edition }}</div>

        <Button v-if="!token.isClaimed" class="token-select__token-button" @click="onTokenSelect(token.edition)">Select</Button>
        <div v-else class="token-select__token-description">Claimed</div>
      </div>
    </template>
  </div>
</template>

<script setup>
import Button from '@/ui/Button.vue'

import { onMounted, ref } from 'vue'
import { getBalance } from '@/logic/mint'
import { useLayoutStore, useSelectStore } from '@/store'

const props = defineProps({
  isFft: {
    type: Boolean,
  },
})

const layoutStore = useLayoutStore()
const selectStore = useSelectStore()

const tokens = ref([])
const isLoaded = ref(false)

onMounted(async () => {
  const list = await getBalance(props.isFft)
  tokens.value = list.sort((a, b) => a.isClaimed - b.isClaimed)
  isLoaded.value = true
})

function onTokenSelect(tokenId) {
  selectStore.tokenId = tokenId
  layoutStore.closeModal()
}
</script>

<style lang="sass">
.token-select
  &__token
    display: flex
    justify-content: space-between
    align-items: center

    &-button
      font-size: 16px
      line-height: 16px
      padding: 4px 12px

    &-description
      width: 67px
      text-align: center

    &:not(:last-child)
      margin-bottom: 12px

  &__loading
    text-align: center

</style>